import React, { useEffect } from "react";
import { Form, Input, Button, Radio, Row, Col } from "antd";
import {
  BankOutlined,
  CreditCardOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const DirectDepositForm = ({ value = {}, onChange }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (value) form.setFieldsValue(value);
  }, [value, form]);

  const handleValuesChange = (_, allValues) => {
    if (onChange) onChange(allValues);
  };

  // Dynamic bank accounts
  const accounts = value.accounts || [1];

  const addAccount = () => {
    const newAccounts = [...accounts, accounts.length + 1];
    form.setFieldsValue({ ...form.getFieldsValue(), accounts: newAccounts });
    if (onChange) onChange({ ...form.getFieldsValue(), accounts: newAccounts });
  };

  return (
    <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
      {/* Do you have bank account? */}
      <Row align="middle" gutter={8} style={{ marginBottom: 12 }}>
        <Col>
          <BankOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col>
          <h3 style={{ margin: 0 }}>{t('onboarding.doYouHaveBankAccount')}</h3>
        </Col>
      </Row>

      <Form.Item
        name="hasAccount"
        rules={[{ required: true, message: t('onboarding.bankNameValidation') }]}
      >
        <Radio.Group style={{ display: "flex", gap: 20 }}>
          <Radio value="yes">{t('onboarding.yes')}</Radio>
          <Radio value="no">{t('onboarding.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      {form.getFieldValue("hasAccount") === "yes" && (
        <>
          {(form.getFieldValue("accounts") || [1]).map((acc, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                padding: 16,
                marginBottom: 16,
              }}
            >
              {/* Section Header */}
              <Row align="middle" gutter={8} style={{ marginBottom: 12 }}>
                <Col>
                  <CreditCardOutlined
                    style={{ fontSize: 18, color: "#1677ff" }}
                  />
                </Col>
                <Col>
                  <h3 style={{ margin: 0 }}>
                    {t('onboarding.bankName')} {acc}
                  </h3>
                </Col>
              </Row>

              {/* Fields */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={`bankName_${acc}`}
                    label={t('onboarding.bankName')}
                    rules={[{ required: true, message: t('onboarding.bankNameValidation') }]}
                  >
                    <Input placeholder={t('onboarding.bankNamePlaceholder')} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={`accountType_${acc}`}
                    label={t('onboarding.accountType')}
                    rules={[{ required: true, message: t('onboarding.typeCodeValidation') }]}
                  >
                    <Input placeholder={t('onboarding.typeCodePlaceholder')} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={`routingNumber_${acc}`}
                    label={t('onboarding.routingNumber')}
                    rules={[{ required: true, message: t('onboarding.routingNumberValidation') }]}
                  >
                    <Input placeholder={t('onboarding.routingNumberPlaceholder')} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={`accountNumber_${acc}`}
                    label={t('onboarding.accountNumber')}
                    rules={[{ required: true, message: t('onboarding.accountNumberValidation') }]}
                  >
                    <Input placeholder={t('onboarding.accountNumberPlaceholder')} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={`amount_${acc}`}
                    label={t('onboarding.amountOrPercent')}
                    rules={[{ required: true, message: t('onboarding.amountValidation') }]}
                  >
                    <Input placeholder={t('onboarding.amountPlaceholder')} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ))}

          {/* Add Bank Account Button */}
          <Button
            type="dashed"
            block
            icon={<PlusOutlined />}
            onClick={addAccount}
          >
            {t('onboarding.addAnotherBankAccount')}
          </Button>
        </>
      )}
    </Form>
  );
};

export default DirectDepositForm;
